<template>
    <div>
        <div class="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-3">
            <div class="summary-chip">
                <p class="chip-label mb-1">Total {{ option ? 'pagado' : 'refinanciado' }}</p>
                <h5 class="chip-value mb-0">{{ formatoNumero(totalMontoPagado) }} {{ moneda }}</h5>
            </div>
            <button @click="handleImprimir" class="btn btn-dark dashboard-action-btn" :disabled="!ready || pagos.length === 0">
                Generar Excel <i class="fa-solid fa-download ms-1"></i>
            </button>
        </div>

        <div class="table-wrapper">
            <table class="table table-hover align-middle mb-0 pagos-table" id="myTable">
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>Beneficiario</th>
                        <th>No. Referencia</th>
                        <th>Monto</th>
                        <th>Fecha pagado</th>
                        <th>IFI</th>
                        <th>No. Cuenta</th>
                        <th>Sucursal</th>
                        <th class="text-center">Imagen</th>
                    </tr>
                </thead>
                <tbody v-if="ready && pagos.length > 0">
                    <tr v-for="pago in pagos" :key="pago.id">
                        <td><span class="id-badge">#{{ pago.id }}</span></td>
                        <td class="cliente-nombre">{{ pago.nombreCliente }}</td>
                        <td>{{ pago.noReferenciaRecibo }}</td>
                        <td>{{ formatoNumero(pago.montoPagado) }} {{ moneda }}</td>
                        <td>{{ dateFormat(pago.fechaPagado) }}</td>
                        <td>{{ pago.ifi }}</td>
                        <td>{{ pago.noCuenta }}</td>
                        <td>{{ pago.sucursal }}</td>
                        <td class="text-center">
                            <button type="button" class="btn btn-sm btn-inverse-primary" @click="pagoSlug(pago.slug)"
                                data-bs-toggle="modal" data-bs-target="#exampleModal">
                                <i class="fa-solid fa-image"></i>
                            </button>
                        </td>
                    </tr>
                </tbody>
                <tbody v-else-if="ready && pagos.length === 0">
                    <tr>
                        <td colspan="9" class="text-center py-4 empty-state">
                            <i class="fa-regular fa-folder-open me-2"></i>
                            No hay registros disponibles para esta consulta.
                        </td>
                    </tr>
                </tbody>
                <tbody v-else>
                    <tr>
                        <td colspan="9" class="text-center py-4">
                            <div class="spinner-border text-warning" role="status">
                                <span class="visually-hidden">Loading...</span>
                            </div>
                        </td>
                    </tr>
                </tbody>
                <tfoot>
                    <tr class="totals-row">
                        <td colspan="3" class="text-end"><strong>Total:</strong></td>
                        <td>{{ formatoNumero(totalMontoPagado) }} {{ moneda }}</td>
                        <td colspan="5"></td>
                    </tr>
                </tfoot>
            </table>
        </div>

        <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header border-0 pb-0">
                        <h1 class="modal-title fs-5" id="exampleModalLabel">Recibo de pago</h1>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <div class="contenedor text-center">
                            <div v-if="reciboLoading" class="spinner-border text-primary" role="status">
                                <span class="visually-hidden">Loading...</span>
                            </div>
                            <img v-else-if="reciboUrl" class="imagen-recibo" :src="reciboUrl" alt="Recibo">
                            <p v-else class="text-muted mb-0">No se pudo cargar el recibo.</p>
                        </div>
                    </div>
                    <div class="modal-footer border-0 pt-0">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cerrar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Swal from "sweetalert2";
import Security from "../security";
import DataTables from "datatables.net";
import ExcelJS from "exceljs";


export default {
    data() {
        return {
            ready: false,
            pagos: [],
            moneda: "lps",
            imgPath: process.env.VUE_APP_IMAGE_URL,
            reciboUrl: "",
            reciboLoading: false,
            totalMontoPagado: 0,
            tableInstance: null,
            datatableLanguage: {
                lengthMenu: "Mostrar _MENU_ registros",
                search: "Buscar:",
                info: "Mostrando _START_ a _END_ de _TOTAL_ registros",
                infoEmpty: "Mostrando 0 a 0 de 0 registros",
                infoFiltered: "(filtrado de _MAX_ registros totales)",
                zeroRecords: "No se encontraron resultados",
                emptyTable: "No hay datos disponibles en la tabla",
                paginate: {
                    first: "Primero",
                    previous: "Anterior",
                    next: "Siguiente",
                    last: "Último"
                }
            },
            pago: {
                slug: ''
            }
        }
    },
    props: {
        startDate: new Date,
        endDate: new Date,
        option: Boolean,
    },
    watch: {
        startDate() {
            this.fetchPagos();
        },
        endDate() {
            this.fetchPagos();
        },
        option() {
            this.fetchPagos();
        }
    },
    beforeMount() {
        this.fetchPagos();
    },
    beforeUnmount() {
        this.destroyDataTable();
        this.revokeReciboUrl();
    },
    updated() {
        if (this.ready && this.pagos.length > 0 && !this.tableInstance) {
            this.initializeDataTable();
        }
    },
    methods: {
        fetchPagos() {
            this.destroyDataTable();
            this.ready = false;
            if (this.option) {
                this.getPagosByRange();
            } else {
                this.getAllReadecuted();
            }
        },
        getPagosByRange() {
            let payload = {
                startDate: this.startDate,
                endDate: this.endDate
            }
            fetch(process.env.VUE_APP_API_URL + `/admin/pagos/allByRange`, Security.requestOptions(payload))
                .then((response) => response.json())
                .then((response) => {
                    if (response.error) {
                        Swal.fire({
                            position: 'top-end',
                            icon: "error",
                            title: response.error,
                            showConfirmButton: false,
                            timer: 1500,
                        });

                    } else {
                        this.pagos = response.data.pagos || [];
                        this.ready = true;
                        this.calculateTotalMonto();
                    }
                })
                .catch(error => {
                    Swal.fire({
                        position: 'top-end',
                        icon: "error",
                        title: error,
                        showConfirmButton: false,
                        timer: 1500,
                    });
                });
        },
        getAllReadecuted() {
            fetch(process.env.VUE_APP_API_URL + `/admin/pagos/allReadecuated`, Security.requestOptions({}))
                .then((response) => response.json())
                .then((response) => {
                    if (response.error) {
                        Swal.fire({
                            position: 'top-end',
                            icon: "error",
                            title: response.error,
                            showConfirmButton: false,
                            timer: 1500,
                        });

                    } else {
                        this.pagos = response.data.pagos || [];
                        this.ready = true;
                        this.calculateTotalMonto();
                    }
                })
                .catch(error => {
                    Swal.fire({
                        position: 'top-end',
                        icon: "error",
                        title: error,
                        showConfirmButton: false,
                        timer: 1500,
                    });
                });
        },
        initializeDataTable() {
            const myTable = document.querySelector("#myTable");
            if (myTable && !this.tableInstance) {
                this.tableInstance = new DataTables(myTable, {
                    language: this.datatableLanguage
                });
            }
        },
        destroyDataTable() {
            if (this.tableInstance && typeof this.tableInstance.destroy === 'function') {
                this.tableInstance.destroy();
                this.tableInstance = null;
            }
        },
        calculateTotalMonto() {
            this.totalMontoPagado = 0;
            if (this.pagos) {
                this.pagos.forEach(pago => {
                    this.totalMontoPagado += pago.montoPagado;
                });
            }
        },
        formatoNumero(numero) {
            return new Intl.NumberFormat("en-US", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }).format(numero || 0)
        },
        dateFormat(param) {
            var fecha = new Date(param);
            var dia = ('0' + fecha.getUTCDate()).slice(-2);
            var mes = ('0' + (fecha.getUTCMonth() + 1)).slice(-2);
            var anio = fecha.getUTCFullYear();
            return dia + '/' + mes + '/' + anio;
        },
        revokeReciboUrl() {
            if (this.reciboUrl) {
                URL.revokeObjectURL(this.reciboUrl);
                this.reciboUrl = "";
            }
        },
        async pagoSlug(slug) {
            this.pago.slug = slug
            this.revokeReciboUrl();
            this.reciboLoading = true;
            try {
                this.reciboUrl = await Security.authenticatedBlobUrl(`/admin/pagos/recibo/${encodeURIComponent(slug)}`);
            } catch (error) {
                console.error(error);
                this.reciboUrl = "";
            } finally {
                this.reciboLoading = false;
            }
        },
        handleImprimir() {
            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet(this.depto ? this.depto[0] : "Data");

            worksheet.columns = [
                { header: "Beneficiario", key: "beneficiario", width: 40 },
                { header: "No Referencia recibo", key: "noReferencia", width: 20 },
                { header: "Total Monto", key: "monto", width: 20 },
                { header: "Capital Pago", key: "capitalPago", width: 20 },
                { header: "Interes Pago", key: "interesPago", width: 20 },
                { header: "Mora Pago", key: "moraPago", width: 20 },
                { header: "Fecha Pagado", key: "fechaPagado", width: 20 },
                { header: "IFI", key: "ifi", width: 20 },
                { header: "No. Cuenta", key: "noCuenta", width: 20 },
                { header: "Sucursal", key: "sucursal", width: 20 },
                { header: "Usuario Encargado", key: "usuario", width: 20 },
                { header: "Pago Realizado por", key: "usuarioPago", width: 20 },
            ];

            worksheet.getRow(1).font = { bold: true };

            const mappedData = this.pagos.map((pago) => ({
                beneficiario: pago.nombreCliente,
                noReferencia: pago.noReferenciaRecibo,
                monto: pago.montoPagado,
                capitalPago: pago.capitalPago,
                interesPago: pago.interesPago,
                moraPago: pago.moraPago,
                fechaPagado: new Date(pago.fechaPagado),
                ifi: pago.ifi,
                noCuenta: pago.noCuenta,
                sucursal: pago.sucursal,
                usuario: (pago.encargado && pago.encargado !== 'Andrés Molina') ? pago.encargado : '',
                usuarioPago: (pago.nombreUsuario && pago.nombreUsuario !== 'Andrés Molina') ? pago.nombreUsuario : '',
            }));

            worksheet.addRows(mappedData);
            worksheet.getColumn('fechaPagado').numFmt = 'dd/mm/yyyy';

            worksheet.addTable({
                name: 'PagosTable',
                ref: 'A1',
                headerRow: true,
                style: {
                    theme: 'TableStyleMedium2',
                    showRowStripes: true,
                },
                columns: worksheet.columns.map(col => ({ name: col.header, filterButton: true })),
                rows: mappedData.map(row => worksheet.columns.map(col => row[col.key])),
            });

            workbook.xlsx.writeBuffer().then((data) => {
                const blob = new Blob([data], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                });
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.setAttribute("hidden", "");
                a.setAttribute("href", url);
                a.setAttribute("download", `Pagos-${this.dateFormat(this.startDate)}-${this.dateFormat(this.endDate)}.xlsx`);
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
            });
        },

    },

}
</script>

<style scoped>
.table-wrapper {
    border: 1px solid #e5eaf0;
    border-radius: 16px;
    overflow: hidden;
    background: #ffffff;
}

.summary-chip {
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 14px;
    padding: 12px 14px;
}

.chip-label {
    color: #64748b;
    font-size: 0.82rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.35px;
}

.chip-value {
    color: #0f172a;
    font-weight: 700;
}

.dashboard-action-btn {
    border-radius: 12px;
    padding: 0.62rem 1rem;
    font-weight: 600;
    background: #111827 !important;
    border-color: #111827 !important;
    box-shadow: 0 8px 20px rgba(17, 24, 39, 0.25);
}

.dashboard-action-btn:hover {
    background: #1f2937 !important;
    border-color: #1f2937 !important;
}

.pagos-table thead th {
    background: #f8fafc;
    color: #111827;
    border-bottom: 1px solid #e5e7eb;
    font-weight: 700;
    white-space: nowrap;
}

.pagos-table tbody tr {
    border-bottom: 1px solid #f1f5f9;
}

.pagos-table tbody tr:hover {
    background: #f8fafc;
}

.id-badge {
    background: #eef2ff;
    color: #3730a3;
    border: 1px solid #c7d2fe;
    padding: 0.2rem 0.55rem;
    border-radius: 999px;
    font-weight: 600;
    font-size: 0.82rem;
}

.cliente-nombre {
    font-weight: 600;
    color: #111827;
}

.empty-state {
    color: #64748b;
    font-weight: 500;
}

.totals-row {
    background: #111827;
    color: #fff;
}

:deep(.dataTables_wrapper .dataTables_length),
:deep(.dataTables_wrapper .dataTables_info) {
    text-align: center;
    width: 100%;
}

:deep(.dataTables_wrapper .dataTables_length) {
    margin-top: 6px;
}

:deep(.dataTables_wrapper .dataTables_info) {
    margin-top: 6px;
}

.imagen-recibo {
    width: 100%;
    border-radius: 12px;
    border: 1px solid #e5e7eb;
}
</style>
